<div class="banner">
    <img src="/assets/img/banner/2.jpg" alt="Banner">
</div>
<div class="container-fluid innerPageMenu">
    <div class="row">
        <div class="col-md-3">
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>Legal</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a routerLink="/privacy-policy">Privacy Policy</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <div id="acom">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="inner-card">
                                <h4 class="card-title">Privacy Policy</h4>
                                <div class="card-body text-justify">
                                    <p class="lead text-justify inner-lead">Maharana Pratap Public School respects and protects the
                                        privacy of the individuals that access the information and use the services
                                        provided through them. Individually identifiable information about the User will
                                        not be wilfully disclosed to any third party without first receiving the User’s
                                        permit, as covered in this Privacy Policy. Please read our privacy policy
                                        carefully to get a clear understanding of how we collect, use, protect or
                                        otherwise handle your Personally Identifiable Information in accordance with our
                                        website.
                                    </p>
                                    <p class="lead text-justify inner-lead">Maharana Pratap Public School will, on best effort basis,
                                        provide remittance details to enable the User to take up queries if any, with
                                        the beneficiary institution. The user is advised to retain remittance details
                                        for any future correspondence with the institution & their bankers.
                                    </p>

                                    <h4 class="card-title"> Scope Of This Policy</h4>
                                    <p class="inner-lead lead text-justify">The Policy does not apply to the procedures
                                        and practices followed by entities that are not managed, owned or controlled by
                                        mppskkr.com or to the people that are not engaged, employed or managed by
                                        mppskkr.com. mppskkr.com is fully held by Maharana Pratap Public School.
                                        This Policy is specific to mppskkr.com and does not apply to Maharana Pratap Public School or other websites or internet services that are part of or to - be
                                        - part of Maharana Pratap Public School.</p>

                                    

                                    <p class="inner-lead lead text-justify fw-bold">How do we protect your information?
                                    </p>
                                    <p class="inner-lead lead text-justify">Our website is scanned on a regular basis
                                        for security holes and known vulnerabilities in order to make your visit to our
                                        site as safe as possible.</p>
                                    <p class="inner-lead lead text-justify">Your personal information is contained
                                        behind secured networks and is only accessible by a limited number of persons
                                        who have special access right s to such systems, and are required to keep the
                                        information confidential. In addition, all sensitive/credit information you
                                        supply is encrypted via Secure Socket Layer (SSL) technology.</p>
                                    <p class="inner-lead lead text-justify">All transactions are processed through a
                                        gateway provider and are not stored or processed on our servers in any case .
                                    </p>

                                    

                                    <h4 class="card-title"> Contact Us</h4>
                                    <p class="inner-lead lead text-justify">If there are any questions regarding this
                                        privacy policy, you may contact us using the information below.</p>
                                    <p class="inner-lead lead text-justify"><a href="mailto:maharanapratapschool@yahoo.co.in">maharanapratapschool@yahoo.co.in</a></p>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>